<template>
  <div :id="'polygon-container-' + id" class="polygon-container" />
  <!-- <div class="polygon-map">
    <div :id="'map-container-' + id" class="map-container" />
  </div> -->
</template>

<script>
export default {
  name: "Polygons",
  props: {
    id: {
      type: Number,
      required: true
    },
    polygons: {
      type: Array,
      default() {
        return [];
      }
      // required: true
    }
  },
  data() {
    return {
      elementId: "polygon-container-" + this.id,
      map: null,
      showMarker: false
    };
  },
  // head () {
  //   return {
  //     script: [
  //       { src: 'https://maps.googleapis.com/maps/api/js?key=' + process.env.GOOGLE_MAP_API_KEY, defer: true, callback: this.onScriptLoaded }
  //     ]
  //   };
  // },
  computed: {},
  watch: {
    polygons(newVal, oldVal) {
      // console.log('watch polygons', newVal);
      if (this.map) {
        this.getPolygons();
      }
    }
  },
  mounted() {
    const self = this;
    const mapContainer = document.getElementById(
      "polygon-container-" + self.id
    );
    const customMap = document.createElement("div");
    customMap.id = self.elementId;
    customMap.className = "polygons";
    mapContainer.appendChild(customMap);

    if (
      typeof window.google === "object" &&
      typeof window.google.maps === "object"
    ) {
      this.onScriptLoaded();
    } else {
      const script = document.createElement("script");
      script.onload = this.onScriptLoaded;
      script.type = "text/javascript";
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        process.env.VUE_APP_GOOGLE_MAP_API_KEY;
      document.head.appendChild(script);
    }

    // mapContainer.addEventListener('scroll', this.onTouchEvent, { passive: true });
    // mapContainer.addEventListener('touchmove', this.onTouchEvent, { passive: true });
    // mapContainer.addEventListener('touchstart', this.onTouchEvent, { passive: true });
    // self.getPolygons();
  },
  methods: {
    onScriptLoaded() {
      console.log("Loaded google map api");
      this.$nextTick(() => {
        this.getPolygons();
      });
    },
    getPolygonCenter(polygonCoords) {
      // console.log('getpolygonCenter', polygonCoords);
      const bounds = new window.google.maps.LatLngBounds();
      // The Bermuda Triangle
      // var polygonCoords = [
      //   new google.maps.LatLng(25.774252, -80.190262),
      //   new google.maps.LatLng(18.466465, -66.118292),
      //   new google.maps.LatLng(32.321384, -64.757370),
      //   new google.maps.LatLng(25.774252, -80.190262)
      // ];

      for (let i = 0; i < polygonCoords.length; i++) {
        bounds.extend(polygonCoords[i]);
      }

      // The Center of the Bermuda Triangle - (25.3939245, -72.473816)
      // console.log(bounds.getCenter());
      return bounds.getCenter();
    },
    getPolygons() {
      const self = this;
      const google = window.google;
      // console.log('------------default mapPolygons ----- \n' + JSON.stringify(self.polygons));
      let center = { lat: 25.0593739, lng: 121.5445842 }; // default
      const polygons = self.polygons;
      if (polygons && polygons.length) {
        const p = polygons[0].polygons[0];
        // get first location of 1 polygon
        const cenPoint1 = p[Object.keys(p)[0]];
        // console.log('center: ', cenPoint1);
        center = { lat: cenPoint1.x, lng: cenPoint1.y };
      }

      // init map
      const options = {
        // center: { lat: 25.0593739, lng: 121.5445842 }, // 如果有畫了多邊形，應該要根據這個拉到中心
        center,
        zoom: 14, // 16
        // Disable Satellite option:
        mapTypeControl: false,
        // Disable street view.
        streetViewControl: false
      };

      const map = new google.maps.Map(
        document.getElementById(self.elementId),
        options
      );
      self.map = map;

      if (polygons && polygons.length) {
        // 建立多邊形
        // loop layer 1 : map
        for (let i = 0; i < polygons.length; ++i) {
          const mapPolygon = polygons[i];
          for (let j = 0, jLen = mapPolygon.polygons.length; j < jLen; ++j) {
            try {
              const path = [];
              for (const c of mapPolygon.polygons[j]) {
                // path.push({ lat: c.x, lng: c.y});
                path.push(new google.maps.LatLng(c.x, c.y));
              }
              const defaultPolygon = new google.maps.Polygon({
                path,
                // strokeColor: '#fca503',
                strokeColor: "#fc3d03",
                // strokeColor: '#bA0000', // 線條顏色
                // strokeOpacity: 0.5,  // 線條透明度
                strokeWeight: 2,
                strokePosition: google.maps.StrokePosition.CENTER,
                fillColor: "#f00",
                // fillColor: '#fcba03',
                fillOpacity: 0.35,
                editable: false
              });

              defaultPolygon.setMap(map);

              // set marker
              if (this.showMarker) {
                const polygonCenter = this.getPolygonCenter(path);
                const marker = new google.maps.Marker({
                  position: polygonCenter,
                  map,
                  title: mapPolygon.name,
                  label: {
                    color: "black",
                    fontWeight: "normal", // 'lighter',
                    text: mapPolygon.name
                  },
                  icon: {
                    path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW
                  }
                  // visible: false
                  // icon: {
                  //   // path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                  //   scale: 5,
                  //   fillColor: 'blue',
                  //   fillOpacity: 0.3,
                  //   strokeWeight: 0.5
                  // }
                });
                marker.setMap(map);
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
      }
      // this.drawCircle()
    },
    drawCircle() {
      // console.log("--------drawCircle------");
      // get center
      let center = { lat: 25.0593739, lng: 121.5445842 }; // default
      let citymap = {
        km1: {
          center: { lat: 25.00, lng: 121.5445842 },
          meter: 1000
        },
        km2: {
          center: { lat: 25.00, lng: 121.5445842 },
          meter: 2000
        },
        km4: {
          center: { lat: 25.00, lng: 121.5445842 },
          meter: 4000
        }
      };
      for (let city in citymap) {
        // Add the circle for this city to the map.
        var cityCircle = new google.maps.Circle({
          strokeColor: "#2E86C1", //圓圈的邊線
          strokeOpacity: 0.8, //邊線的透明度
          strokeWeight: 2, //邊線的寬度
          fillColor: "Transparent", //圓圈內部的填滿色
          // fillColor: "lightblue",
          fillOpacity: 0.35,
          map: this.map,
          center: citymap[city].center,
          radius: citymap[city].meter
        });
        console.log(cityCircle);
      }
    }
  }
};
</script>

<style>
.polygons {
  width: 100%;
  height: 100%;
}
.polygon-container {
  height: 100%;
  width: 100% !important;
}
/* @media screen and (max-width: 1024px) {
  .map-container {
    width: 100% !important;
  }
} */
</style>
